import { render, staticRenderFns } from "./CompleteCarrier.vue?vue&type=template&id=bbb83aac&scoped=true&"
import script from "./CompleteCarrier.vue?vue&type=script&lang=js&"
export * from "./CompleteCarrier.vue?vue&type=script&lang=js&"
import style0 from "./CompleteCarrier.vue?vue&type=style&index=0&id=bbb83aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb83aac",
  null
  
)

export default component.exports